import React from 'react'
import DashboardLayout from '../DashboardLayout'
import Layout from '../Layout'
import SubLots from '../../../utils/CommonFunctionality/SellerDashboard/SubLots'
import { useTranslation } from 'react-i18next'
import { useEffect } from 'react'

const MyLots = (props) => {
    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])
    const { t } = useTranslation()
    return (
        <Layout props={props}>
            <DashboardLayout title={t('my_lots')}>
                <SubLots
                    multipleChangeStatus={false}
                    searchBar={1}
                    status={1}
                    resultsPerPage={1}
                    changeStatus={1}
                    withoutAuction={1}
                    copyItem={1}
                    slidertheme={'ArtAuction'}
                />
            </DashboardLayout>
        </Layout>
    )
}

export default MyLots
